import React, { Component } from 'react'
import Select from 'react-select';
import { Input, Button } from 'reactstrap'
import './Product.css'
import unSave from '../../assets/icons/save.png'
import Modal from 'react-modal';
import * as actionCreators from '../../Actions/Index';
import { withRouter, Link } from 'react-router-dom';
import { connect } from "react-redux";
import Save from '../../assets/icons/unsave.png'
import Cookies from 'universal-cookie';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios from 'axios';
import $ from 'jquery'
import { Helmet } from 'react-helmet'

import Demo from './ImageCrousel'

const cookies = new Cookies();

const techCompanies = [
    { label: "Pakistan", value: 1 },
    { label: "United Kingdom", value: 2 },
    { label: "Saudi Arabia", value: 3 },
    { label: "USA", value: 4 },
    { label: "UAE", value: 5 },
    { label: "Italy", value: 6 },
    { label: "Oman", value: 7 },
];

class Card extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            startOrder: false,
            expanded: false,
            showTitles: false,
            saveCount: props.saveCount,
            country: "",
            countrySelected: false,
            account: {},
            slides: [],
            errors: {},
            orderlist: {},
            errorMsg: "",
            OpenModel: false,
            modalIsOpen: false,
            errorMsgcon: "",
            selectedOption: "",
            ordersuc: "",
            Images: [],
            slideCount: 5,
            options: {
                navigation: true,
                pagination: true,
                paginationClickable: true,
                scrollBar: false,
                loop: false
            }
        };
        this.myDivToFocus = React.createRef()
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    toggleOption(prop) {
        this.setState({
            options: Object.assign({}, this.state.options, {
                [prop]: !this.state.options[prop],
            }),
        })
    }
    openModal() {
        this.setState({ modalIsOpen: true });
    }
    componentWillMount() {

        // axios.get(`http://brands.us-east-2.elasticbeanstalk.com/api/product/GetImagesBySKU?SKU=${this.props.SKU}`).then((response) => {
        //     let res = JSON.parse(JSON.stringify(response.data));

        //       this.setState({slides: res});
        // })


        // var morph_api_url = 'https://api.morph.io/SelectSoft/select_jigar/data.json';
        // var morph_api_params = {
        //     // Keep this key secret!
        //     key: '7hDDGSosf23K7474Bd4P',
        //     query: `Select Images.ImageURL from Images where Images.SKU = '${this.props.SKU}'`
        // };

        // let _this = this;
        // $.ajax({
        //     url: morph_api_url + '?' + $.param(morph_api_params),
        //     dataType: 'jsonp',
        //     success: function (data) {
        //         let res = JSON.parse(JSON.stringify(data));
        //         _this.setState({ slides: res });
        //     }
        // });

    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
    }

    closeModal() {
        this.setState({ modalIsOpen: false })
    }
    handleOnClick = (event) => {
        this.setState({ startOrder: true });
        //.current is verification that your element has rendered
        if (this.myDivToFocus.current) {
            this.myDivToFocus.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            })
        }


    }
    handleChange(field, e) {
        let account = this.state.account;
        account[field] = e.target.value;
        this.setState({ account });
    }
    expand = () => {
        this.setState({ expanded: !this.state.expanded })
    }
    handleValidation() {
        let account = this.state.account;
        let errors = {};
        let formIsValid = true;
        if (!account["whatsapp"]) {

            if (!account["address"]) {
                formIsValid = false;
                errors["address"] = "Address Cannot be empty";
            }
            if (!account["phoneNo"]) {
                formIsValid = false;
                errors["phoneNo"] = "phoneNo Cannot be empty";
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    contactSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.state.errorMsg = "";
            var phone = "";
            if (this.state.selectedOption.value == 1) {
                phone = this.state.account["phoneNo"]
            }
            else {
                phone = this.state.account["whatsapp"]
            }
            if (cookies.get("domain") && cookies.get("usfid")) {
                //  this.props.createOrder(order);
                this.state.ordersuc = "Order Successfully Placed";
            }
            else {
                this.setState({ modalIsOpen: true });
            }
        }
        else {
            if (this.state.errors["address"]) {
                this.state.errorMsg = "Address cannot be empty!";
            }
            else if (this.state.errors["phoneNo"]) {
                this.state.errorMsg = "Phone cannot be empty!";
            }
            else {
                this.state.errorMsg = "Something not right";
            }
        }
    }


    toggle = (pid) => {

        document.addEventListener('click', this.handleClickOutside, true);

        if (cookies.get("domain") == "SelectFashion") {
            var userID = cookies.get("usfid");
            var cat = {
                "productID": pid,
                "userID": userID
            }
            this.setState({ expanded: !this.state.expanded, saveCount: this.state.saveCount + 1 })

            axios.post(`http://brands.us-east-2.elasticbeanstalk.com/api/saved/AddSaveProduct`, cat,
                { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
                    let res = JSON.parse(JSON.stringify(response));

                    if (res.statusText === "OK") {


                    } else {
                        console.log("something went wrong");
                    }
                })
        }

        else {
            this.setState({ showPopup: true })
        }

    };
    toggleSaveCounter = (pid) => {

        var userID = cookies.get("usfid");
        var cat = {
            "productID": pid,
            "userID": userID
        }
        this.setState({ expanded: !this.state.expanded, saveCount: this.state.saveCount - 1 });

        axios.post(`http://brands.us-east-2.elasticbeanstalk.com/api/saved/DeleteSaveProduct`, cat,
            { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
                let res = JSON.parse(JSON.stringify(response));

                if (res.statusText === "OK") {


                } else {
                    console.log("something went wrong");
                }
            })


    };


    SelecthandleChange = selectedOption => {
        this.setState({ selectedOption: selectedOption });
        if (selectedOption.value == 1) {
            this.setState({ countrySelected: false, country: selectedOption.label });
        }
        else {
            this.setState({ countrySelected: true, country: selectedOption.label });
        }
    };

    componentDidMount() {

    }
    data = {
        "pageNumber": 1,
        "pageSize": 24,
        "filter":
        {
            "Color": [],
            "Brand": [],
            "FabricType": [],
            "Design": [],
            "DupattaType": [],
            "DressType": [],
            "Price": []
        }
    };
    /* ---------------------------------------- */
    handleChangemodel(field, e) {
        let account = this.state.account;
        account[field] = e.target.value;
        this.setState({ account });
    }
    handleValidationmodel() {
        let account = this.state.account;
        let errors = {};
        let formIsValid = true;

        if (!account["username"]) {
            formIsValid = false;
            errors["username"] = "username Cannot be empty";
        }
        if (!account["password"]) {
            formIsValid = false;
            errors["password"] = "password Cannot be empty";
        }
        if (!account["conpassword"]) {
            formIsValid = false;
            errors["conpassword"] = "conpassword Cannot be empty";
        }
        if (account["conpassword"] != account["password"]) {
            formIsValid = false;
            errors["notsame"] = "password doesnt match";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    contactSubmitmodel(e) {
        e.preventDefault();

        if (this.handleValidationmodel()) {
            this.state.errorMsgcon = "";
            var phone = "";
            if (this.state.selectedOption.value == 1) {
                phone = this.state.account["phoneNo"]
            }
            else {
                phone = this.state.account["whatsapp"]
            }
            var orderacc = {
                "phoneNo": phone,
                "password": this.state.account["password"],
                "username": this.state.account["username"]
            }

            var order = {
                "sender": { "name": "Saifullah Alam", "email": "sa19980113@gmail.com" },
                "to": [{ "name": "Web Email", "email": "saifullah.alam552@gmail.com" }],
                "replyTo": { "name": "Saifullah Alam", "email": "sa19980113@gmail.com" },
                "subject": "SelectFashion Order recived",
                "htmlContent": `\n<div>\n    <div>\n        <div><b>Country:</b></div>\n        <div>${this.state.country}</div>\n        <br />\n    </div>\n    <div>\n        <div><b>phoneNumber:</b></div>\n        <div>${phone}</div>\n        <br />\n    </div>\n    <div>\n        <div><b>Address:</b></div>\n        <div>${this.state.account["address"]}</div>\n        <br />\n    </div>\n    <div>\n        <div><b>Username:</b></div>\n        <div>${this.state.account["username"]}</div>\n        <br />\n    <div>\n        <div><b>password:</b></div>\n        <div>${this.state.account["password"]}</div>\n        <br />\n    </div>\n    </div>\n</div>    <div>\n        <div><b>productID:</b></div>\n        <div>${this.props.id}</div>\n        <br />\n    </div>\n    </div>        \n     `
                , "textContent": "\n        Full Name: Saifullah Alam, \n        Phone No.: 03316800069,\n        Message: ghjgjhg \n     "
            }


            axios.post(`https://api.sendinblue.com/v3/smtp/email`, order,
                { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414", "api-key": "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" } }).then((response) => {
                    let res = JSON.parse(JSON.stringify(response));

                    if (res.statusText === "OK") {


                    } else {
                        console.log("something went wrong");
                    }
                })
            //  this.props.createOrderUserAccount(orderacc,order);
            this.closeModal();
            this.state.ordersuc = "Order Successfully Placed";
        }
        else {
            if (this.state.errors["username"]) {
                this.state.errorMsgcon = "UserName cannot be empty!";
            }
            else if (this.state.errors["password"]) {
                this.state.errorMsgcon = "Password cannot be empty!";
            }
            else if (this.state.errors["conpassword"]) {
                this.state.errorMsgcon = "Confirm Password cannot be empty!";
            }
            else if (this.state.errors["notsame"]) {
                this.state.errorMsgcon = "Password does not match!";
            }
            else if (this.state.errors["inCorrect"]) {
                this.state.errorMsgcon = this.state.errors["inCorrect"];
            }
            else {
                this.state.errorMsgcon = "Something not right";
            }

        }
    }
    brandTour = () => {
        window.open(this.props.productURL, "_blank");
        var data = {
            "USID": cookies.get("SFUSID"),
            "EventTitle": "brand Tour",
            "ProductID": this.props.id,
            "OrderID": 0
        }
        return axios.post(`http://brands.us-east-2.elasticbeanstalk.com/api/Event/saveUserEvents`, data).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            if (res.data === "00") {

            } else {
                console.log("something went wrong");
            }
        })
    }

    render() {
        const { selectedOption } = this.state;
        const { slides } = this.state
        return (
            <div>
                <Helmet>
                    <meta property="og:url" content={`http://selectfashion.pk/#/item/id=${this.props.ProductID}`} />
                    <meta property="og:type" content="product" />
                    <meta property="og:title" content={this.props.brand + " " + this.props.title} />
                    {this.state.slides.length > 0 ?
                        <meta property="og:image" content={this.state.slides[0]} />
                        : null}
                </Helmet>
                <li className="friend-item">
                    <div className="row">
                        <div className="col-md-6 offset-md-4 offset-sm-0 text-left">
                            <div className="itemBrand">
                                <span to={`brand/${this.props.brand}`} className="itemBrandName" 
                                style={{ color: "#365899" }}>{this.props.brand}</span>
                            </div>
                            <div className="item-title">
                                <h1 className="item-title-tag">{this.props.title}</h1>
                            </div>
                        </div>
                    </div>


                    {/* <img className="Fimage" src={this.props.image}></img> */}



                    <Demo slides={[this.props.image]}> </Demo>

                    {/* {this.state.Images.length == 1?
                        <LazyLoadImage
                        className="Fimage innFImage"
                         alt={this.props.title +" "+ this.props.brand}
                         effect="blur"
                         src={this.state.Images[0].ImageURL}  />
                    :null} */}
                    <span className="sprice-tag" style={{ display: `${this.props.sale ? "" : 'none'}` }}>50% Off</span>
                </li>
                <div className="createOrder">
                    <div className="row" id="rowsec" style={{ marginTop: "-50px" }}>
                        <div className="col-md-6 offset-md-3 offset-sm-0">
                            <div className="row">
                                <div className="col-6 col-md-6 col-sm-6">
                                    <h4 className="Fprice"><span className="currency">Rs</span>{this.props.price}</h4>
                                </div>
                                <div className="col-6 col-md-6 col-sm-6" style={{ paddingTop: "10px" }}>
                                    <span className="" onClick={() => this.toggleSaveCounter(this.props.id)}
                                        style={{ marginLeft: '0px', display: `${this.state.expanded ? "" : 'none'}` }}>
                                        <img style={{ width: "40px" }} src={Save} alt="shani" />
                                    </span>
                                    <span className="" onLoad={this.props.flag == 1 ? this.expand : null}
                                        onClick={() => this.toggle(this.props.id)}
                                        style={{ marginLeft: '0px', display: `${this.state.expanded ? "none" : ''}` }}>
                                        <img style={{ width: "40px" }} src={unSave} alt="shani" />
                                    </span>
                                    <span className="totalSave"><span>(<span>{this.state.saveCount}</span>)</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 col-md-3 col-sm-6 offset-0 offset-md-1 offset-sm-0 order-8 order-md-0 order-sm-8">
                            <div className="ordernow">
                                <h3 onClick={this.handleOnClick}>Start Order</h3>
                            </div>
                        </div>
                        <div className="col-md-4">
                            {/* <div className="row">
                <div className="col-6 col-md-6 col-sm-6">
                    <h4 className="Fprice"><span className="currency">Rs</span>{this.props.price}</h4>
                </div>
                <div className="col-6 col-md-6 col-sm-6">
                    <span className="" onClick={() => this.toggleSaveCounter(this.props.id)}
                     style={{marginLeft:'0px',display: `${this.state.expanded ? "": 'none'}`}}>
                    <img style={{width: "60px"}} src={Save}  />
                    </span>
                    <span className="" onLoad={this.props.flag == 1 ?this.expand:null}
                     onClick={() => this.toggle(this.props.id)} 
                     style={{marginLeft:'0px',display: `${this.state.expanded? "none": ''}`}}>
                    <img style={{width: "60px"}} src={unSave}/>
                    </span>
                    <span className="totalSave"><span>(<span>{this.state.saveCount}</span>)</span></span>
                </div>
            </div> */}

                        </div>
                        <div className="col-6 col-md-3 col-sm-6 order-sm-last order-last order-md-0">
                            <div className="ordernow">
                                <Link style={{ float: "right" }} className="productTour" onClick={this.brandTour}>Brand Tour</Link>
                            </div>
                        </div>
                    </div>
                    <hr />

                    {this.state.startOrder ?
                        <form id="section2" name="contactform" className="contactform text-left" onSubmit={this.contactSubmit.bind(this)} ref={this.myDivToFocus}>
                            <label>Select Country</label>
                            <Select options={techCompanies} value={selectedOption} onChange={this.SelecthandleChange} />
                            {!this.state.countrySelected ?
                                <div style={{ marginBottom: "57px" }}>
                                    <div className="address">
                                        <label>Address</label>
                                        <Input placeholder="e.g House 1, C block, DLF Phase 1, Sector 24, Karachi" name="address" onChange={this.handleChange.bind(this, "address")} />
                                    </div>
                                    <div className="address">
                                        <label>Phone</label>
                                        <Input placeholder="e.g 03001234565" name="phoneNo" onChange={this.handleChange.bind(this, "phoneNo")} />
                                    </div>
                                    <div className="errorMessageOrder">
                                        <span>{this.state.errorMsg}</span>
                                    </div>
                                    <div className="successMessageOrder">
                                        <span>{this.state.ordersuc}</span>
                                    </div>
                                    <div className="button">
                                        <Button style={{ width: "200px" }} color="success" >Place an Order</Button>
                                    </div>
                                </div> : <div><div className="address">
                                    <label>Phone</label>
                                    <Input placeholder="e.g 03001234565" name="phoneNo" onChange={this.handleChange.bind(this, "whatsapp")} />
                                </div>
                                    <div className="whatsapp">
                                        <p>Enter your WhatsApp number we will contact you shortly!</p>
                                    </div>
                                    <div className="errorMessageOrder">
                                        <span>{this.state.errorMsg}</span>
                                    </div>
                                    <div className="successMessageOrder">
                                        <span>{this.state.ordersuc}</span>
                                    </div>
                                    <div className="button">
                                        <Button style={{ width: "200px" }} color="success">Place an Order</Button>
                                    </div>
                                </div>
                            }
                        </form> : null}
                </div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}

                    contentLabel="Example Modal"
                >
                    <div className="leftlogin">

                        <div className="signUpOrder">

                            <form name="contactform" className="contactform" onSubmit={this.contactSubmitmodel.bind(this)}>

                                <div className="f0n8F FATdn " style={{ marginTop: "5%" }}>
                                    <label for="f955a63d446b2c" className="_9nyy2">User Name</label>
                                    <input className="_2hvTZ pexuQ zyHYP" onChange={this.handleChangemodel.bind(this, "username")}
                                        name="username" type="text" />
                                </div>
                                <div className="f0n8F FATdn " style={{ marginTop: "5%" }}>
                                    <label for="f955a63d446b2c" className="_9nyy2">Password</label>
                                    <input className="_2hvTZ pexuQ zyHYP" onChange={this.handleChangemodel.bind(this, "password")}
                                        name="password" type="password" />
                                </div>
                                <div className="f0n8F FATdn " style={{ marginTop: "5%" }}>
                                    <label for="f955a63d446b2c" className="_9nyy2">Confirm Password</label>
                                    <input className="_2hvTZ pexuQ zyHYP" onChange={this.handleChangemodel.bind(this, "conpassword")}
                                        name="conpassword" type="password" />
                                </div>
                                <div className="errorMessage">
                                    <span>{this.state.errorMsgcon}</span>
                                </div>
                                <div className="loginButtonOrder">
                                    <span onClick={this.closeModal} className="buttonCancel btn">Cancel</span>
                                    <Button type="submit" color="success">Confirm</Button>
                                </div>
                            </form>


                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}
const mapStateToProps = (state) => (

    {
        orderlist: state.orderlist,
    });

const mapDispatchToProps = dispatch => {
    return {
        createOrderUserAccount: (orderacc, order) => dispatch(actionCreators.createOrderUserAccount(orderacc, order)),
        createOrder: (order) => dispatch(actionCreators.createOrder(order)),
    }

}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Card))